<template>
<!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-模拟显示-单图组
    -->
    <div @click.stop="$parent.$parent.onEditer(index)">
      <div class="drag optional" :class="{selected:index === selectedIndex}">
        <div class="diy-imageSingle" :style="{ 
            paddingTop: item.style.paddingTop + 'px', 
          paddingBottom: item.style.paddingBottom + 'px', 
        background: item.style.background,
        width:item.style.width+'%',
        height:(item.style.height+50)+'px'}" style="margin: auto;">
          <div class="item-image" :key="index" v-for="(imageSingle, index) in item.data" 
          :style="{padding: item.style.paddingTop + 'px ' + item.style.paddingLeft + 'px 0'}">
            <img v-img-url="imageSingle.imgUrl"
            :style="{height:(item.style.height+50)+'px'}">
          </div>
        </div>
        <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style>
.diy-imageSingle img{ max-width: 100%;}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/ImageSingle.vue